module.exports = __webpack_public_path__ + "static/media/lootbox.84be5285.png";